module.exports = __webpack_public_path__ + "img/householdequipment5.3cc1a655.png";